import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface RegionalExample {
  id: number;
  country: string;
  region: string;
  project: string;
  description: string;
  impact: string;
  image: string;
  alt: string;
  flag: string;
}

interface RegionalExamplesProps {
  examples: RegionalExample[];
}

const RegionalExamples = ({ examples }: RegionalExamplesProps) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 lg:p-8 shadow-natural">
      <div className="mb-8">
        <h3 className="font-heading font-bold text-2xl text-text-primary mb-2">
          Regional Success Stories
        </h3>
        <p className="text-text-secondary">
          Real-world examples from India and UAE demonstrating carbon credit impact
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 gap-6">
        {examples.map((example) => (
          <div key={example.id} className="bg-surface border border-border rounded-xl overflow-hidden hover:shadow-natural transition-all duration-300">
            <div className="relative h-48 overflow-hidden">
              <AppImage
                src={example.image}
                alt={example.alt}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 bg-card/90 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center space-x-2">
                <span className="text-2xl">{example.flag}</span>
                <span className="text-sm font-medium text-text-primary">{example.country}</span>
              </div>
            </div>
            
            <div className="p-6">
              <div className="flex items-center space-x-2 mb-3">
                <Icon name="MapPinIcon" size={16} className="text-primary" />
                <span className="text-sm font-medium text-primary">{example.region}</span>
              </div>
              
              <h4 className="font-heading font-bold text-lg text-text-primary mb-2">
                {example.project}
              </h4>
              
              <p className="text-sm text-text-secondary mb-4 leading-relaxed">
                {example.description}
              </p>
              
              <div className="bg-conversion/10 border border-conversion/20 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <Icon name="ChartBarIcon" size={20} className="text-conversion flex-shrink-0" />
                  <div>
                    <p className="text-xs font-medium text-text-secondary mb-1">Impact Achieved</p>
                    <p className="text-sm font-bold text-text-primary">{example.impact}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegionalExamples;